import { initializeApp } from 'firebase/app';
import {
    Auth,
    browserLocalPersistence,
    browserPopupRedirectResolver,
    browserSessionPersistence,
    getAuth,
    inMemoryPersistence,
    initializeAuth,
} from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const firebaseConfig = {
    apiKey: 'AIzaSyBmB3DCkgfNMjJoJV0ClnMntnp-9BdZdU8',
    authDomain: 'therapyapp-dd272.firebaseapp.com',
    databaseURL: 'https://therapyapp-dd272-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'therapyapp-dd272',
    storageBucket: 'therapyapp-dd272.appspot.com',
    messagingSenderId: '665397421364',
    appId: '1:665397421364:web:75a706a10d8e5375527161',
    measurementId: 'G-1V506VNYQR'
  };

const app = initializeApp(firebaseConfig);

/**
 * Avoid Firebase Auth's default IndexedDB persistence because a stalled browser
 * database can leave an otherwise successful sign-in promise unresolved.
 */
const createAuth = (): Auth => {
    try {
        return initializeAuth(app, {
            persistence: [browserLocalPersistence, browserSessionPersistence, inMemoryPersistence],
            popupRedirectResolver: browserPopupRedirectResolver,
        });
    } catch (error) {
        // Hot module replacement may reuse an Auth instance created before this module reloads.
        if ((error as { code?: string }).code === 'auth/already-initialized') {
            return getAuth(app);
        }
        throw error;
    }
};

// Allow local commerce and storefront checks without contacting production Functions.
const functionsEmulatorHost = process.env.REACT_APP_FIREBASE_FUNCTIONS_EMULATOR_HOST;
if (functionsEmulatorHost) {
    const [host, portText] = functionsEmulatorHost.split(':');
    const port = Number(portText);
    if (host && Number.isInteger(port) && port > 0) {
        connectFunctionsEmulator(getFunctions(app), host, port);
    }
}

// App Check is enabled remotely by supplying the public reCAPTCHA Enterprise site key.
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY;
if (appCheckSiteKey && typeof window !== 'undefined') {
    initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
    });
}

export const auth: Auth = createAuth();
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);
export const analytics: Analytics = getAnalytics(app);
